(function () {
  var timers  = new WeakMap();
  var indices = new WeakMap();

  // ── Shared helpers ────────────────────────────────────────────────────────

  function createBtn(dir) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vvc-iwt-btn vvc-iwt-' + dir;
    btn.setAttribute('aria-label', dir === 'prev' ? 'Previous' : 'Next');
    var pts = dir === 'prev' ? '15 18 9 12 15 6' : '9 18 15 12 9 6';
    btn.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"' +
      ' stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
      '<polyline points="' + pts + '"></polyline></svg>';
    return btn;
  }

  function stopAuto(el) {
    clearInterval(timers.get(el));
  }

  // ── MOBILE — CSS scroll-snap (IWT section) ────────────────────────────────

  function getSlides(carousel) {
    return Array.from(
      carousel.querySelectorAll(':scope > .m-iwt-carousel__wrapper > .m-iwt')
    );
  }

  function updateIndex(carousel) {
    var slides = getSlides(carousel);
    var sl = carousel.scrollLeft, closest = 0, min = Infinity;
    slides.forEach(function (s, i) {
      var d = Math.abs(s.offsetLeft - sl);
      if (d < min) { min = d; closest = i; }
    });
    indices.set(carousel, closest);
  }

  function scrollTo(carousel, idx) {
    var slides = getSlides(carousel);
    if (!slides[idx]) return;
    carousel.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' });
    indices.set(carousel, idx);
  }

  function mobileNext(carousel) {
    var n = getSlides(carousel).length;
    scrollTo(carousel, ((indices.get(carousel) || 0) + 1) % n);
  }

  function mobilePrev(carousel) {
    var n = getSlides(carousel).length;
    scrollTo(carousel, ((indices.get(carousel) || 0) - 1 + n) % n);
  }

  function startMobileAuto(carousel) {
    stopAuto(carousel);
    timers.set(carousel, setInterval(function () { mobileNext(carousel); }, 4000));
  }

  function initMobile(carousel) {
    if (carousel.dataset.vvcMobile === '1') return;
    if (getSlides(carousel).length < 2) return;
    carousel.dataset.vvcMobile = '1';
    indices.set(carousel, 0);

    var wrap = document.createElement('div');
    wrap.className = 'vvc-iwt-wrap';
    carousel.parentNode.insertBefore(wrap, carousel);
    wrap.appendChild(carousel);

    var prev = createBtn('prev');
    var next = createBtn('next');
    wrap.appendChild(prev);
    wrap.appendChild(next);

    prev.addEventListener('click', function () {
      stopAuto(carousel); mobilePrev(carousel);
      setTimeout(function () { startMobileAuto(carousel); }, 3500);
    });
    next.addEventListener('click', function () {
      stopAuto(carousel); mobileNext(carousel);
      setTimeout(function () { startMobileAuto(carousel); }, 3500);
    });
    carousel.addEventListener('touchstart', function () { stopAuto(carousel); }, { passive: true });
    carousel.addEventListener('touchend', function () {
      setTimeout(function () { updateIndex(carousel); startMobileAuto(carousel); }, 800);
    }, { passive: true });

    startMobileAuto(carousel);
  }

  function destroyMobile(carousel) {
    if (carousel.dataset.vvcMobile !== '1') return;
    carousel.dataset.vvcMobile = '0';
    stopAuto(carousel);
    var wrap = carousel.parentNode;
    if (wrap && wrap.classList.contains('vvc-iwt-wrap')) {
      wrap.parentNode.insertBefore(carousel, wrap);
      wrap.remove();
    }
  }

  // ── DESKTOP / TABLET — Swiper (IWT section) ───────────────────────────────

  function startDesktopAuto(carousel) {
    stopAuto(carousel);
    timers.set(carousel, setInterval(function () {
      if (carousel.swiper) carousel.swiper.slideNext();
    }, 4000));
  }

  function initDesktop(carousel) {
    if (carousel.dataset.vvcDesktop === '1') return;

    if (!carousel.swiper) {
      setTimeout(function () { initDesktop(carousel); }, 80);
      return;
    }

    carousel.dataset.vvcDesktop = '1';

    var inner = carousel.closest('.m-section__inner');
    if (!inner) return;
    inner.classList.add('vvc-iwt-inner');

    var prev = createBtn('prev');
    var next = createBtn('next');
    prev.classList.add('vvc-iwt-btn--desktop');
    next.classList.add('vvc-iwt-btn--desktop');
    inner.appendChild(prev);
    inner.appendChild(next);

    prev.addEventListener('click', function () {
      if (!carousel.swiper) return;
      stopAuto(carousel);
      carousel.swiper.slidePrev();
      setTimeout(function () { startDesktopAuto(carousel); }, 3500);
    });
    next.addEventListener('click', function () {
      if (!carousel.swiper) return;
      stopAuto(carousel);
      carousel.swiper.slideNext();
      setTimeout(function () { startDesktopAuto(carousel); }, 3500);
    });

    carousel.swiper.on('touchStart', function () { stopAuto(carousel); });
    carousel.swiper.on('touchEnd', function () {
      setTimeout(function () { startDesktopAuto(carousel); }, 3500);
    });

    startDesktopAuto(carousel);
  }

  function destroyDesktop(carousel) {
    if (carousel.dataset.vvcDesktop !== '1') return;
    carousel.dataset.vvcDesktop = '0';
    stopAuto(carousel);
    var inner = carousel.closest('.m-section__inner');
    if (inner) {
      inner.classList.remove('vvc-iwt-inner');
      ['.vvc-iwt-btn--desktop.vvc-iwt-prev', '.vvc-iwt-btn--desktop.vvc-iwt-next'].forEach(function (sel) {
        var el = inner.querySelector(sel);
        if (el) el.remove();
      });
    }
  }

  // ── IWT observer / init ───────────────────────────────────────────────────

  function checkIWT(carousel) {
    var isMobile = MinimogTheme && MinimogTheme.config && MinimogTheme.config.mqlMobile;
    var isSwiper = carousel.classList.contains('swiper-container');

    if (!isSwiper && isMobile) {
      destroyDesktop(carousel);
      initMobile(carousel);
    } else if (isSwiper && !isMobile) {
      destroyMobile(carousel);
      initDesktop(carousel);
    } else {
      destroyMobile(carousel);
      destroyDesktop(carousel);
    }
  }

  function observeIWT(carousel) {
    var mo = new MutationObserver(function () { checkIWT(carousel); });
    mo.observe(carousel, { attributes: true, attributeFilter: ['class'] });
    setTimeout(function () { checkIWT(carousel); }, 200);
  }

  // ── ICON BOX — Swiper (all screen sizes, arrows hide when nothing to scroll)

  function swiperCanScroll(swiper) {
    /* Swiper hides touch & nav when slides <= slidesPerView */
    return swiper.allowTouchMove !== false;
  }

  function syncIconBoxArrows(iconBox, prev, next, swiper) {
    var canScroll = swiperCanScroll(swiper);
    prev.style.display = canScroll ? '' : 'none';
    next.style.display = canScroll ? '' : 'none';
  }

  function startIconBoxAuto(iconBox, swiper) {
    stopAuto(iconBox);
    timers.set(iconBox, setInterval(function () {
      iconBoxSlideNext(swiper);
    }, 4000));
  }

  function iconBoxSlideNext(swiper) {
    /* Manually loop: works whether Swiper was initialised with loop:true or false */
    var total = swiper.slides ? swiper.slides.length : 0;
    if (!total) return;
    var next = ((swiper.activeIndex || 0) + 1) % total;
    swiper.slideTo(next);
  }

  function iconBoxSlidePrev(swiper) {
    var total = swiper.slides ? swiper.slides.length : 0;
    if (!total) return;
    var prev = ((swiper.activeIndex || 0) - 1 + total) % total;
    swiper.slideTo(prev);
  }

  function initIconBox(iconBox) {
    if (iconBox.dataset.vvcIconBox === '1') return;

    /* Wait for icon-box.js to init its Swiper */
    var slideContainer = iconBox.querySelector('.swiper-container');
    if (!slideContainer || !slideContainer.swiper) {
      setTimeout(function () { initIconBox(iconBox); }, 100);
      return;
    }

    iconBox.dataset.vvcIconBox = '1';
    var swiper = slideContainer.swiper;

    /* Wrap the swiper container in a new div so arrows flank exactly the slides */
    var overlay = document.createElement('div');
    overlay.className = 'vvc-iconbox-wrap';
    slideContainer.parentNode.insertBefore(overlay, slideContainer);
    overlay.appendChild(slideContainer);

    var prev = createBtn('prev');
    var next = createBtn('next');
    prev.classList.add('vvc-iconbox-btn');
    next.classList.add('vvc-iconbox-btn');
    overlay.appendChild(prev);
    overlay.appendChild(next);

    /* Hide the original slider-controls (we're replacing them) */
    var origControls = iconBox.querySelector('.m-slider-controls');
    if (origControls) origControls.style.display = 'none';

    prev.addEventListener('click', function () {
      stopAuto(iconBox);
      iconBoxSlidePrev(swiper);
      setTimeout(function () { startIconBoxAuto(iconBox, swiper); }, 3500);
    });
    next.addEventListener('click', function () {
      stopAuto(iconBox);
      iconBoxSlideNext(swiper);
      setTimeout(function () { startIconBoxAuto(iconBox, swiper); }, 3500);
    });

    swiper.on('touchStart', function () { stopAuto(iconBox); });
    swiper.on('touchEnd', function () {
      setTimeout(function () { startIconBoxAuto(iconBox, swiper); }, 3500);
    });

    startIconBoxAuto(iconBox, swiper);
  }

  // ── Setup ─────────────────────────────────────────────────────────────────

  function setup() {
    /* IWT carousels */
    document.querySelectorAll('.m-iwt-carousel[data-enable-slider=true]').forEach(observeIWT);

    /* Icon-box carousels */
    document.querySelectorAll('m-icon-box[data-enable-slider=true]').forEach(function (el) {
      setTimeout(function () { initIconBox(el); }, 300);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
